<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
<div class="invoicing-account-container">
  <div class="px-6 py-4">
    <div class="flex justify-content-between align-items-center mb-4 gap-2 flex-wrap">
      <p class="text-xl font-semibold m-0">{{ 'INVOICING.TITLE' | translate }}</p>
      <div class="flex gap-2 align-items-center flex-wrap">
        <span *ngIf="importInProgress && importProgressText" class="text-sm text-600 align-self-center">
          {{ importProgressText }}
        </span>
        <p-button
          [label]="'INVOICING.BUTTON.IMPORT_FILE' | translate"
          icon="pi pi-upload"
          severity="info"
          [disabled]="importInProgress"
          (onClick)="onImportFile()">
        </p-button>
        <input
          #ibbiolFileInput
          type="file"
          accept=".csv,.txt,.xlsx,.xls"
          (change)="onIbbiolFileSelected($event)"
          hidden
        />
        <p-button
          [label]="'INVOICING.BUTTON.NEW_IBBIOL' | translate"
          icon="pi pi-plus"
          severity="info"
          (onClick)="openIbbiolDialog()">
        </p-button>
        <p-button
          [label]="'INVOICING.BUTTON.NEW_NON_IBBIOL' | translate"
          icon="pi pi-plus"
          severity="success"
          (onClick)="openCreateDialog()">
        </p-button>
      </div>
    </div>
    <div class="bg-white">
      <p-toolbar styleClass="mb-4 w-full gap-2 invoicing-toolbar">
        <div class="w-full flex justify-content-end gap-2">
          <button pButton pRipple class="p-button-outlined p-button-sm btn-clear"
            icon="pi pi-filter-slash btn-icon-spacing" [label]="'common.filters.clear' | translate"
            (click)="clearAllFilters()">
          </button>
          <button pButton pRipple class="p-button p-button-sm btn-filter"
            icon="pi pi-filter btn-icon-spacing" [label]="'common.filters.show' | translate"
            (click)="toggleFilters()">
          </button>
        </div>
      </p-toolbar>
      <p-table
        [value]="displayRows"
        [loading]="accountsLoading"
        dataKey="rowId"
        [scrollable]="true"
        scrollHeight="600px"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 20, 50, 100]"
        paginatorPosition="bottom"
        paginatorAlignment="center"
        [tableStyle]="{ 'min-width': '70rem' }"
        styleClass="mt-2 p-datatable-sm p-datatable-gridlines invoicing-accounts-table">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem"></th>
            <th pSortableColumn="account.code" class="nowrap-col">
              {{ 'INVOICING.TABLE.CODE' | translate }}
              <p-sortIcon field="account.code"></p-sortIcon>
            </th>
            <th pSortableColumn="account.startDate" class="nowrap-col">
              {{ 'INVOICING.TABLE.START_DATE' | translate }}
              <p-sortIcon field="account.startDate"></p-sortIcon>
            </th>
            <th pSortableColumn="account.endDate" class="nowrap-col">
              {{ 'INVOICING.TABLE.END_DATE' | translate }}
              <p-sortIcon field="account.endDate"></p-sortIcon>
            </th>
            <th class="nowrap-col">{{ 'INVOICING.TABLE.CURRENCY' | translate }}</th>
            <th pSortableColumn="account.status" class="nowrap-col">
              {{ 'INVOICING.TABLE.STATUS' | translate }}
              <p-sortIcon field="account.status"></p-sortIcon>
            </th>
            <th class="nowrap-col">{{ 'INVOICING.TABLE.ACTIONS' | translate }}</th>
          </tr>
          <tr *ngIf="showFilterRow" class="filters" [formGroup]="filtersForm">
            <th></th>
            <th class="filters">
              <div class="filter-w flex align-items-center gap-1 w-full">
                <input pInputText class="p-inputtext w-full" formControlName="code"
                  (ngModelChange)="applyFilters()" [placeholder]="'INVOICING.TABLE.CODE' | translate" />
                <button pButton pRipple type="button" icon="pi pi-filter-slash"
                  class="p-button-rounded p-button-text p-button-secondary p-button-sm"
                  *ngIf="filtersForm.get('code')?.value"
                  (click)="filtersForm.get('code')?.reset(''); applyFilters()"
                  [pTooltip]="'common.filters.clear' | translate" tooltipPosition="top">
                </button>
              </div>
            </th>
            <th></th>
            <th></th>
            <th></th>
            <th class="filters">
              <div class="filter-w flex align-items-center gap-1 w-full">
                <p-multiSelect [options]="statusOptions" formControlName="statuses"
                  optionLabel="label" optionValue="value" [showClear]="false"
                  [placeholder]="'INVOICING.TABLE.STATUS' | translate"
                  (onChange)="applyFilters()" styleClass="w-full" class="w-full" appendTo="body"
                  [maxSelectedLabels]="1">
                </p-multiSelect>
                <button pButton pRipple type="button" icon="pi pi-filter-slash"
                  class="p-button-rounded p-button-text p-button-secondary p-button-sm"
                  *ngIf="filtersForm.get('statuses')?.value?.length"
                  (click)="filtersForm.get('statuses')?.reset([]); applyFilters()"
                  [pTooltip]="'common.filters.clear' | translate" tooltipPosition="top">
                </button>
              </div>
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <p-button type="button" pRipple [text]="true" [rounded]="true" [plain]="true"
                [icon]="isRowExpanded(row.rowId) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                (onClick)="toggleRow(row.rowId)">
              </p-button>
            </td>
            <td class="nowrap-col font-medium">{{ row.account.code }}</td>
            <td class="nowrap-col">{{ row.account.startDate | date:'dd/MM/yyyy' }}</td>
            <td class="nowrap-col">{{ row.account.endDate ? (row.account.endDate | date:'dd/MM/yyyy') : '-' }}</td>
            <td class="nowrap-col">{{ row.account.currency ?? '-' }}</td>
            <td>
              <p-tag [value]="row.account.status" [severity]="getStatusSeverity(row.account.status)"></p-tag>
            </td>
            <td>
              <div class="flex gap-2 align-items-center">
                <p-button icon="pi pi-pencil" [rounded]="true" [outlined]="true" severity="info" size="small"
                  [pTooltip]="'common.edit' | translate" tooltipPosition="bottom"
                  (onClick)="openEditDialog(row.account)">
                </p-button>
                <p-button icon="pi pi-trash" [rounded]="true" [outlined]="true" severity="danger" size="small"
                  [pTooltip]="'common.delete' | translate" tooltipPosition="bottom"
                  (onClick)="confirmDelete($event, row.account)">
                </p-button>
                <p-button [icon]="isAccountActive(row.account) ? 'pi pi-lock-open' : 'pi pi-lock'"
                  [rounded]="true" [outlined]="true" severity="success" size="small"
                  [disabled]="!isAccountActive(row.account) && isEndDateReached(row.account.endDate)"
                  [pTooltip]="(isAccountActive(row.account) ? 'INVOICING.ACTIONS.DEACTIVATE' : 'INVOICING.ACTIONS.ACTIVATE') | translate"
                  tooltipPosition="bottom"
                  (onClick)="toggleAccountStatus(row.account)">
                </p-button>
              </div>
            </td>
          </tr>
          <tr *ngIf="isRowExpanded(row.rowId)">
            <td colspan="7">
              <div class="p-3 expansion-panel flex justify-content-center">
                <p-table
                  [value]="row.groups"
                  [tableStyle]="{ 'min-width': '40rem' }"
                  styleClass="p-datatable-sm p-datatable-gridlines panel-datatable">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="nowrap-col">{{ 'INVOICING.TABLE.ONE_ERP_CLIENT_NAME' | translate }}</th>
                      <th>{{ 'INVOICING.TABLE.PROJECT_NAME' | translate }}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-group>
                    <tr>
                      <td class="nowrap-col">
                        <p-tag *ngIf="group.client !== '-'" [value]="group.client" severity="info"></p-tag>
                        <span *ngIf="group.client === '-'" class="text-500">-</span>
                      </td>
                      <td>
                        <div class="flex flex-wrap gap-1">
                          <p-tag *ngFor="let project of group.projects" [value]="project" severity="secondary"></p-tag>
                          <span *ngIf="!group.projects.length" class="text-500">-</span>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="2" class="text-500 text-center py-3">
                        {{ 'INVOICING.DETAIL.EMPTY' | translate }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="text-center py-6">
              <div class="flex flex-column align-items-center gap-2">
                <i class="pi pi-inbox text-4xl text-400"></i>
                <p class="text-500 m-0">{{ 'INVOICING.TABLE.EMPTY' | translate }}</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<p-dialog
  [header]="isEditMode ? ('INVOICING.DIALOG.EDIT_TITLE' | translate) : ('INVOICING.DIALOG.ADD_TITLE' | translate)"
  [(visible)]="editDialogVisible"
  [modal]="true"
  [style]="{ width: '450px' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDialog()">
​
  <form [formGroup]="form" class="p-fluid mt-3">
​
    <div class="field mb-4">
      <label for="client" class="text-700 font-medium mb-2 block">
        {{ 'INVOICING.FORM.CLIENT_LABEL' | translate }} <span class="text-red-500">*</span>
      </label>
      <p-multiSelect
        id="client"
        [options]="clientOptions"
        formControlName="clientIds"
        optionLabel="displayName"
        optionValue="id"
        filterBy="name"
        display="chip"
        [filter]="true"
        appendTo="body"
        [placeholder]="'INVOICING.FORM.CLIENT_PLACEHOLDER' | translate"
        (onChange)="onClientsChange($event)">
      </p-multiSelect>
    </div>
    <div class="field mb-4">
      <label for="project" class="text-700 font-medium mb-2 block">
        {{ 'INVOICING.FORM.PROJECT_LABEL' | translate }} <span class="text-red-500">*</span>
      </label>
      <p-multiSelect
        id="project"
        [options]="projectOptions"
        formControlName="projectIds"
        optionLabel="name"
        optionValue="id"
        display="chip"
        [filter]="true"
        appendTo="body"
        [placeholder]="'INVOICING.FORM.PROJECT_PLACEHOLDER' | translate"
        [disabled]="!form.get('clientIds')?.value?.length"
        (onChange)="onProjectsChange($event)">
      </p-multiSelect>
    </div>
    <div class="field mb-4">
      <label for="code" class="text-700 font-medium mb-2 block">
        {{ 'INVOICING.FORM.CODE_LABEL' | translate }} <span class="text-red-500">*</span>
      </label>
      <input
        id="code"
        pInputText
        formControlName="code"
        [placeholder]="'INVOICING.FORM.CODE_PLACEHOLDER' | translate"
      />
      <small class="p-error block mt-2" *ngIf="form.get('code')?.touched && form.get('code')?.hasError('pattern')">
        {{ 'INVOICING.FORM.CODE_FORMAT_ERROR' | translate }}
      </small>
    </div>
    <div class="field mb-4">
      <label for="description" class="text-700 font-medium mb-2 block">
        {{ 'INVOICING.FORM.DESCRIPTION_LABEL' | translate }}
      </label>
      <input
        id="description"
        pInputText
        formControlName="description"
        [placeholder]="'INVOICING.FORM.DESCRIPTION_PLACEHOLDER' | translate"
      />
    </div>
    <div class="field mb-4">
      <label for="currency" class="text-700 font-medium mb-2 block">
        {{ 'INVOICING.FORM.CURRENCY_LABEL' | translate }}
      </label>
      <p-dropdown
        id="currency"
        [options]="currencyOptions"
        formControlName="currency"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        [placeholder]="'INVOICING.FORM.CURRENCY_PLACEHOLDER' | translate">
      </p-dropdown>
    </div>
    <div class="field mb-4">
      <label for="startDate" class="text-700 font-medium mb-2 block">
        {{ 'INVOICING.FORM.START_DATE_LABEL' | translate }} <span class="text-red-500">*</span>
      </label>
      <p-calendar
        id="startDate"
        formControlName="startDate"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        iconDisplay="button"
        appendTo="body"
        [placeholder]="'INVOICING.FORM.START_DATE_PLACEHOLDER' | translate">
      </p-calendar>
    </div>
    <div class="field mb-4">
      <label for="endDate" class="text-700 font-medium mb-2 block">
        {{ 'INVOICING.FORM.END_DATE_LABEL' | translate }}
      </label>
      <p-calendar
        id="endDate"
        formControlName="endDate"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        iconDisplay="button"
        appendTo="body"
        [placeholder]="'INVOICING.FORM.END_DATE_PLACEHOLDER' | translate">
      </p-calendar>
    </div>
    <div class="field mb-4">
      <label for="status" class="text-700 font-medium mb-2 block">
        {{ 'INVOICING.FORM.STATUS_LABEL' | translate }} <span class="text-red-500">*</span>
      </label>
      <p-dropdown
        id="status"
        [options]="formStatusOptions"
        formControlName="status"
        optionLabel="label"
        optionValue="value"
        optionDisabled="disabled"
        appendTo="body"
        [placeholder]="'INVOICING.FORM.STATUS_PLACEHOLDER' | translate">
      </p-dropdown>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="pt-3 border-top-1 border-300">
      <p-button
        [label]="'common.save' | translate"
        icon="pi pi-check"
        (onClick)="saveAccount()"
        [disabled]="form.invalid">
      </p-button>
    </div>
  </ng-template>
</p-dialog>
<p-dialog
  [header]="'INVOICING.IBBIOL_DIALOG.TITLE' | translate"
  [(visible)]="ibbiolDialogVisible"
  [modal]="true"
  [style]="{ width: '450px' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeIbbiolDialog()">
​
  <form [formGroup]="ibbiolForm" class="p-fluid mt-3">
​
    <div class="field mb-4">
      <label for="preProjectCode" class="text-700 font-medium mb-2 block">
        {{ 'INVOICING.FORM.PRE_PROJECT_CODE_LABEL' | translate }} <span class="text-red-500">*</span>
      </label>
      <input
        id="preProjectCode"
        pInputText
        formControlName="preProjectCode"
        [placeholder]="'INVOICING.FORM.PRE_PROJECT_CODE_PLACEHOLDER' | translate"
      />
      <small class="p-error block mt-2" *ngIf="ibbiolForm.get('preProjectCode')?.touched && ibbiolForm.get('preProjectCode')?.hasError('pattern')">
        {{ 'INVOICING.FORM.PRE_PROJECT_CODE_FORMAT_ERROR' | translate }}
      </small>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="pt-3 border-top-1 border-300">
      <p-button
        [label]="'common.save' | translate"
        icon="pi pi-check"
        (onClick)="saveIbbiolAccount()"
        [disabled]="ibbiolForm.invalid">
      </p-button>
    </div>
  </ng-template>
</p-dialog>